import React from 'react'
import { Checkbox, Chip, MenuItem, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { KeyboardArrowDownRounded } from '@mui/icons-material'
import HHFormAutocompleteField from 'components/form-fields/v5/HHFormAutocompleteField'

const FilterMultiSelectField = ({
  sx,
  name,
  control,
  disabled = false,
  label = undefined,
  placeholder = '',
  size = 'medium',
  variant = 'outlined',
  rules = undefined,
  required = false,
  fullWidth = false,
  options,
  noOptionsText,
  disableCloseOnSelect = true,
  openOnFocus = false,
  loading = false,
  getOptionLabel = x => x,
  // This is deprecated but need to verify before we remove
  getOptionSelected = (option, value) => option === value,
  isOptionEqualToValue = (option, value) => option === value,
  onChangeMiddleware = (onChange, item) => {
    onChange(item)
  },
  debug = false,
  slotProps,
  ...rest
}) => {
  return (
    <HHFormAutocompleteField
      sx={{
        '.MuiAutocomplete-inputRoot': {
          flexWrap: 'wrap',
        },
        ...sx,
      }}
      TextFieldProps={{
        defaultSize: true,
      }}
      slotProps={slotProps}
      debug={debug}
      getOptionSelected={getOptionSelected}
      isOptionEqualToValue={isOptionEqualToValue}
      name={name}
      control={control}
      disabled={disabled}
      label={label}
      placeholder={placeholder}
      size={size}
      variant={variant}
      rules={rules}
      required={required}
      fullWidth={fullWidth}
      options={options}
      popupIcon={<KeyboardArrowDownRounded />}
      noOptionsText={noOptionsText}
      onChangeMiddleware={onChangeMiddleware}
      multiple
      disableCloseOnSelect={disableCloseOnSelect}
      renderOption={({ className, ...rest }, option, { selected }) => {
        return (
          <MenuItem key={`${name}-option-${getOptionLabel(label)}`} sx={{ paddingX: 0.5 }} {...rest}>
            <Checkbox checked={selected} />
            <Typography noWrap> {getOptionLabel(option)}</Typography>
          </MenuItem>
        )
      }}
      getOptionLabel={getOptionLabel}
      openOnFocus={openOnFocus}
      loading={loading}
      renderValue={(value, getItemProps) =>
        value.map((option, index) => {
          const { key, ...itemProps } = getItemProps({ index })
          const label = getOptionLabel(option)
          return <Chip variant="outlined" label={label} key={key} {...itemProps} />
        })
      }
      {...rest}
    />
  )
}

FilterMultiSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  rules: PropTypes.object,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  options: PropTypes.array.isRequired,
  noOptionsText: PropTypes.node,
  disableCloseOnSelect: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  openOnFocus: PropTypes.bool,
  loading: PropTypes.bool,
  getOptionSelected: PropTypes.func,
  isOptionEqualToValue: PropTypes.func,
  onChangeMiddleware: PropTypes.func,
  debug: PropTypes.bool,
  slotProps: PropTypes.object,
  sx: PropTypes.object,
}

export default FilterMultiSelectField
